import { computed } from "vue";
import { useBreakpoints } from "@vueuse/core";

// Element Plus breakpoints (matches el-row/el-col xs sm md lg xl)
export const breakpoints = useBreakpoints({
  xs: 0,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1920,
});

export function useResponsive() {
  const isMobile = breakpoints.smaller("sm"); // < 768
  const isTablet = breakpoints.between("sm", "md"); // 768–991
  const isDesktop = breakpoints.greaterOrEqual("md"); // ≥ 992
  const drawerSize = computed(() => {
    if (isMobile.value) return "100%";
    if (isTablet.value) return "85%";
    return "min(960px, 70vw)";
  });
  return { isMobile, isTablet, isDesktop, drawerSize };
}
